// ...existing code...
import { Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DyeingGroup } from '../../../models/production/production-card-forms';
import { DyeingForecastFormGroup } from '../../../models/production/dyeing/dyeing-forecast-forms';
import { DyeingForecastService } from '../../../services/dyeing-forecast.service';
import { DyeingColor } from '../../../models/production/dyeing/dyeing-color';
import { Asset } from '../../../models/asset/asset';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import _ from 'lodash';

@Component({
  selector: 'app-dyeing-forecast-viewer',
  templateUrl: './dyeing-forecast-viewer.component.html',
  styleUrl: './dyeing-forecast-viewer.component.scss',
})
export class DyeingForecastViewerComponent {
  private readonly dyeingForecastService = inject(DyeingForecastService);

  @Input() dyeingForecastFormGroup!: FormGroup<DyeingForecastFormGroup>;
  @Input() dyeingGroups: DyeingGroup[] = [];
  @Input() colors: DyeingColor[] = [];
  @Input() assets: Asset[] = [];
  @Input() onlyView = false;
  disabled = false;

  public assetsSuggestions: Asset[] = [];
  public colorsSuggestions: DyeingColor[] = [];
  dyeingForecastFormGroupSubmitted = false;

  public get quantityInLbsPerProductionCardAfterExtraCalc(): number {
    const base = Number(this.dyeingForecastFormGroup?.controls?.quantityInLbsPerProductionCard?.getRawValue?.() ?? 0);
    let result = base;
    const fabricExtraArray = this.dyeingForecastFormGroup?.controls?.fabricExtraPercentages?.controls || [];
    for (const fabricExtraForm of fabricExtraArray) {
      const percent = Number(fabricExtraForm?.controls?.percentage?.getRawValue?.() ?? 0);
      result += base * (percent / 100);
    }
    return _.round(result, 2);
  }

  public get total(): number {
    const count = this.dyeingForecastFormGroup.value.productionCardCount ?? 0;

    const qtyPerCard = this.quantityInLbsPerProductionCardAfterExtraCalc;

    return _.round(count * qtyPerCard, 2);
  }

  public completeForecast(create: boolean) {
    this.dyeingForecastFormGroupSubmitted = true;
    if (this.dyeingForecastFormGroup.invalid) {
      return;
    }
    this.dyeingForecastService.saveForecast(this.dyeingForecastFormGroup, create);
  }

  public getFabricWeightedPercentage(fabricCode?: string): number {
    if (!fabricCode) {
      return 0;
    }
    const total = this.dyeingForecastService.getFabricWeightedPercentage(this.dyeingForecastFormGroup, fabricCode) * 100;

    return Number(total.toFixed(2));
  }

  public assetTypeAhead(event: AutoCompleteCompleteEvent) {
    const query = event.query;
    this.assetsSuggestions = this.assets.filter((asset) => asset.assetId.toLowerCase().includes(query.toLowerCase()));
  }

  public colorTypeAhead(event: AutoCompleteCompleteEvent) {
    const query = event.query;
    this.colorsSuggestions = this.colors.filter((color) => color.name.toLowerCase().includes(query.toLowerCase()));
  }

  getFabricDescription(fabricCode: string): string {
    return this.dyeingForecastService.getFabric(fabricCode)?.fabric.longDescription ?? '';
  }
}
